import { FormEvent, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { authApi } from '../api';

export function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await authApi.login(username, password);
      navigate((location.state as { from?: string })?.from || '/v3/home', { replace: true });
    } catch (err) {
      const message = err instanceof Error ? err.message : '登录失败';
      setError(`登录失败：${message}`);
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login-hall">
      <section className="login-card">
        <div className="login-seal">工</div>
        <p className="page-kicker">AI 工程督造中枢</p>
        <h1>进入杜工部控制台</h1>
        <p className="muted-text">使用管理员账号登录。登录失败时会显示真实原因，不静默回退。</p>
        <form onSubmit={submit}>
          <label>
            管理员账号
            <input autoFocus autoComplete="username" value={username} onChange={e => setUsername(e.target.value)} />
          </label>
          <label>
            密码
            <input type="password" autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} />
          </label>
          {error ? <p className="error-banner">{error}</p> : null}
          <button className="primary-button" disabled={busy || !username || !password}>
            {busy ? '正在核验...' : '进入控制台'}
          </button>
        </form>
        <small>安全会话 · 单管理员 · 无公开注册</small>
      </section>
    </main>
  );
}
